import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Component to inject security headers via meta tags
 * Note: Some headers like CSP work better when set by the server,
 * but we can set basic ones via meta tags for additional security
 */
export default function SecurityHeaders() {
  useEffect(() => {
    // Skip iframe protection in development/preview/editor environments
    const host = window.location.hostname;
    const isDevOrPreview =
      import.meta.env.DEV ||
      host.includes('localhost') ||
      host.endsWith('lovableproject.com') ||
      host.endsWith('.lovableproject.com') ||
      host.endsWith('lovable.app') ||
      host.endsWith('.lovable.app') ||
      host.endsWith('lovable.dev') ||
      host.endsWith('.lovable.dev');

    if (isDevOrPreview) {
      // Ensure body is visible in preview if previously hidden
      if (document.body.style.display === 'none') {
        document.body.style.display = '';
      }
      return;
    }

    // Production iframe protection - prevent clickjacking
    if (window.self !== window.top) {
      try {
        if (window.top?.location.hostname !== window.location.hostname) {
          window.top.location.href = window.self.location.href;
        }
      } catch (e) {
        // Cross-origin frame detected
        document.body.style.display = 'none';
      }
    }
  }, []);

  return (
    <Helmet>
      {/* Content Security Policy - Relaxed for development */}
      {/* Note: frame-ancestors is intentionally omitted as it only works via HTTP headers */}
      <meta
        httpEquiv="Content-Security-Policy"
        content="
          default-src 'self';
          script-src 'self' 'unsafe-inline' 'unsafe-eval' https: http:;
          style-src 'self' 'unsafe-inline' https:;
          img-src 'self' data: https: http: blob:;
          font-src 'self' data: https:;
          connect-src 'self' https: http: wss: ws:;
          base-uri 'self';
          form-action 'self';
        "
      />
      
      {/* Prevent MIME type sniffing */}
      <meta httpEquiv="X-Content-Type-Options" content="nosniff" />
      
      {/* Enable XSS protection */}
      <meta httpEquiv="X-XSS-Protection" content="1; mode=block" />
      
      {/* Control referrer information */}
      <meta name="referrer" content="strict-origin-when-cross-origin" />
      
      {/* Permissions Policy */}
      <meta
        httpEquiv="Permissions-Policy"
        content="camera=(), microphone=(), geolocation=()"
      />
    </Helmet>
  );
}
